import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  text: 'Abre el manual y localiza el Framework C-R-T-R.'
}, {
  num: '2',
  text: 'Aplica las 4 capas a cualquier tarea que tengas pendiente hoy.'
}, {
  num: '3',
  text: 'Observa cómo la IA entrega un resultado profesional al primer intento.'
}];
export function HowItWorks() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-800/30" data-id="element-82">
      <div className="max-w-5xl mx-auto" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-84">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-85">
            Así de Simple
          </h2>
        </motion.div>

        <div className="relative" data-id="element-86">
          {/* Connecting line desktop */}
          <div className="hidden md:block absolute top-10 left-[10%] right-[10%] h-0.5 bg-cyan-accent/20" data-id="element-87" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-88">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative text-center" data-id="element-89">
                <div className="w-20 h-20 mx-auto bg-navy-900 rounded-full border-2 border-cyan-accent flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(0,229,255,0.3)] relative z-10" data-id="element-90">
                  <span className="text-3xl font-bold text-cyan-glow" data-id="element-91">
                    {step.num}
                  </span>
                </div>
                <p className="text-lg text-gray-300 font-medium px-4" data-id="element-92">
                  {step.text}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}